import { RefObject, useLayoutEffect } from 'react'

export interface AutoScrollRef {
  key: string
  ref: RefObject<HTMLDivElement>
}

export const useAutoScroll = (elements: AutoScrollRef[], scrollToKey?: string) => {
  useLayoutEffect(() => {
    elements.find((element) => element.key === scrollToKey)?.ref.current?.scrollIntoView()
  }, [elements, scrollToKey])
}
